module.exports = __webpack_public_path__ + "static/consult4-4cd958b7606808726d53444391174fe3.jpg";